<template>
    <div>
        <div class="row">
            <div class="col-xl-5 col-12 p-0">
                <div class="h1 labgrotesque-bold text-xl-center text-left px-xl-0 px-4">
                    {{ $t($route.meta.title) }}
                    <hr class="hr-title-mobile">
                </div>
            </div>
        </div>

        <div class="row margin-right-70 mb-3" id="network">
            <div class="col-xl-3 col-lg-6 text-xl-center text-left px-xl-0 px-4 col-partners" v-for="(partner, index) in partners">
                <a class="partners" target="_blank" :href="partner.field_partner_website" :id="'partner-' + index">
                    <img class="img-fluid hvr-grow" :src="partner.field_partner_logo">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "network",

    data() {
        return {
            partners: []
        }
    },
    
    created() {
        axios.get(this.$route.meta.api, this.$root.auth)
        .then(response => {
            this.partners = response.data;

            this.$nextTick(function() {
                this.animationPartners();
            });
        });
    },

    methods: {
        animationPartners() {
            var anime = this.$root.animejs.timeline({loop: false});
            $.each(this.partners, function(index, value) {
                anime.add({
                    targets: '#partner-' + index,
                    opacity: [0,1],
                    easing: "easeInOutQuad",
                    duration: 400
                });
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/network.vue